import {styled} from '../../styled-components';
import {TableCellProps} from './TableCellBase';

export const TableCellStyle = styled.td<TableCellProps>`
    padding: 0;
    text-align: ${props => props.align || 'left'};
    border-bottom: 2px solid ${props => props.theme.color.primary.dark};
    font-size: ${props => props.theme.typography.pxToRem(14)};
`;
